import React, { useState } from 'react';
import { Form, Button, Modal } from '@themesberg/react-bootstrap';
import axiosInstance from "../../api/api";

const DataForm = ({ onAdd }) => {
    const [show, setShow] = useState(false); // Estado para controlar la visibilidad del modal
    const [formData, setFormData] = useState({
        name: '',
        value: '',
    });

    // Manejar cambios en los campos del formulario
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Manejar el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.value) {
            alert('Por favor, completa todos los campos.');
            return;
        }

        try {
            // Hacer la solicitud POST al web service
            const response = await axiosInstance.post('/option/', formData);
            console.log('Respuesta del servidor:', response.data);

            // Si el servidor responde con éxito, llamar a la función onAdd
            onAdd();

            // Limpiar el formulario y cerrar el modal
            setFormData({ name: '', value: '' });
            setShow(false);
        } catch (error) {
            console.error('Error al enviar los datos:', error);
            alert('Hubo un error al enviar los datos. Por favor, intenta nuevamente.');
        }
    };

    return (
        <>
            <Button variant="primary" size={"sm"} onClick={() => setShow(true)}>
                Agregar Registro
            </Button>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Nuevo Registro</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Ingrese el nombre"
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formValue">
                            <Form.Label>Value</Form.Label>
                            <Form.Control
                                type="text"
                                name="value"
                                value={formData.value}
                                onChange={handleChange}
                                placeholder="Ingrese el valor"
                                required
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" className="mt-3">
                            Guardar
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default DataForm;